import React from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalOptionCard,
    StandardModalOptionCardText,
    StandardModalOptionCardTitle,
    StandardModalOptionsGrid,
    StandardModalSection
} from "src/components";

interface AddListingOptionsModalProps {
    open: boolean;
    directoryName: string;
    onClose: () => void;
    onAddSingle: () => void;
    onUploadCsv: () => void;
}

const AddListingOptionsModal = ({
    open,
    directoryName,
    onClose,
    onAddSingle,
    onUploadCsv
}: AddListingOptionsModalProps): React.JSX.Element => (
    <StandardModal
        open={open}
        onClose={onClose}
        widthMode="large"
        title={`Add Listing to Your ${directoryName}`}
        description="Add a single listing manually or upload multiple listings from our CSV template."
        footer={(
            <StandardModalActionGroup style={{ margin: "0 auto" }}>
                <StandardModalActionButton width="140px" onClick={onClose}>
                    Cancel
                </StandardModalActionButton>
            </StandardModalActionGroup>
        )}
    >
        <StandardModalSection>
            <StandardModalOptionsGrid>
                <StandardModalOptionCard>
                    <StandardModalOptionCardText>
                        <StandardModalOptionCardTitle>Add Single Listing</StandardModalOptionCardTitle>
                        <StandardModalDescription>
                            Add one employee, client, company, or business listing manually.
                        </StandardModalDescription>
                    </StandardModalOptionCardText>
                    <StandardModalActionButton $variant="primary" width="170px" onClick={onAddSingle}>
                        Add Single Listing
                    </StandardModalActionButton>
                </StandardModalOptionCard>

                <StandardModalOptionCard>
                    <StandardModalOptionCardText>
                        <StandardModalOptionCardTitle>Upload Multiple Listings</StandardModalOptionCardTitle>
                        <StandardModalDescription>
                            Use the Directory CSV template to prepare and review a list before saving.
                        </StandardModalDescription>
                    </StandardModalOptionCardText>
                    <StandardModalActionButton $variant="primary" width="170px" onClick={onUploadCsv}>
                        Upload CSV File
                    </StandardModalActionButton>
                </StandardModalOptionCard>
            </StandardModalOptionsGrid>
        </StandardModalSection>
    </StandardModal>
);

export default AddListingOptionsModal;
